export const LOTTE_CATEGORY_FIELD = {
    // store
    LARGE_CLASSIFICATION_NAME: 'lrclsNm',
    // f&b
    MEDIUM_CLASSIFICATION_NAME: 'mdclsNm',
    // facility
    SMALL_CLASSIFICATION_NAME: 'smclsNm',

    // poi
    // store
    LARGE_CLASSIFICATION_CODE: 'lrclsCd',

    // f&b
    MEDIUM_CLASSIFICATION_CODE: 'mdclsCd',

    // facility  + L001
    SMALL_CLASSIFICATION_CODE: 'smclsCd',

    OTHER_FACILITY_CODE: 'L001',
};
